import {
  mapState,
  mapMutations
} from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import QrcodeVue from 'qrcode.vue'
import api from '../service/services'
import swal from 'sweetalert2'
// var client = require('emitter-io').connect({
//   host: '35.240.146.79',
//   port: 8888
// })
export default {
  data() {
    return {
      step: 1,
      step_process: '',
      qrcode: '',
      txn_id: '',
      time: 180,
      ref1: '',
      remark: '',
      tt: '',
      channel: {},
      chceck_genqr: 1,
      header: {
        headers: {
          'x-access-token': this.accessToken
          // 'x-access-token': 'c0dcf8c170a64a7491c1f1e45787b951'
        }
      }
    }
  },
  components: {
    Loading,
    QrcodeVue
  },
  computed: {
    ...mapState(['isLoading', 'UUID', 'lang', 'IDWallet', 'SaleID', 'SaleType', 'PaymentType', 'accessToken', 'AmountPayment', 'reponseStatus', 'sale_info', 'printer_step', 'sale_pay', 'Mode', 'Type', 'total','config','sale_subs_slip']),
    ...mapMutations(['onMessageWs', 'clearState'])
  },
  methods: {
    setHeader(){
      this.header = {
        headers: {
          'x-access-token': this.accessToken
        }
      }
      console.log("header",this.header)
    },
    back() {
      this.Soundclick();
      // this.Soundclick();
      const obj = {
        ref_number: this.$store.state.ref_number,
        status: "REJECTED"
      }
      console.log('obj :',obj)
      api.getReceiveC9(obj, this.header,
        result => {
          console.log(result)
          // this.$store.state.printer_step = 1
          // this.$store.commit('clearState')
          // clearInterval(this.step_process)
          // clearInterval(this.tt)
          // this.tt = ''
          // this.time = 180
          // cancel promptpay
          const obj = {
            vending_uuid: this.UUID,
            order_uuid: this.txn_id,
            ref1: this.channel.ref1,
            reason: "cancel"
          }
          console.log(obj)
          api.cancelPromptpay(obj, this.header,
            result => {
              console.log(result)
              if (result.status == 'success') {
                // client.disconnect();
                // this.$router.push({
                //   name: 'Main'
                // })
                this.$store.state.printer_step = 2
              } else {
                alert(JSON.stringify(result))
                // client.disconnect();
                this.$router.push({
                  name: 'Main'
                })
              }
            },
            error => {
              alert(JSON.stringify(error))
              // client.disconnect();
              this.$router.push({
                name: 'Main'
              })
            }
          )
        }, error => {
          alert(JSON.stringify(error))
        }
      )
      // location.reload() //แก้พิมเบิ้ล
    },
    // qrmsg_received(msg_pay) {
    //   console.log(JSON.stringify(msg_pay))
    //   if (msg_pay.status == "done") {
    //     swal.fire({
    //       position: 'top-end',
    //       type: 'success',
    //       title: 'Your work has been saved',
    //       showConfirmButton: false,
    //       timer: 1500
    //     })
    //   }
    // },
    genqrcode() {
      console.log(this.accessToken)
      clearInterval(this.tt)
      const header = {
        headers: {
          'x-access-token': this.accessToken
        }
      }
      console.log("UUID " ,this.UUID)
      console.log("txn_id ",this.txn_id)
      var payload = {
        // vending_uuid: "testing",
        // order_uuid: "testing123",
        vending_uuid: this.UUID,
        order_uuid: this.txn_id,
        // amount: 0.01,
        amount: parseFloat(this.AmountPayment),
        // client_name: "PAYGYM",
        client_name: this.$store.state.config.client.branch,
        terminal_id: this.$store.state.config.vending.terminal_id
        // terminal_id: "PBX_M1"
      }
      console.log(payload)
      api.callqrcode(payload, header,
        (result) => {
          console.info("QR = " + JSON.stringify(result))
          if (result.status === 'success') {
            this.step = 1
            this.channel = result
            this.qrcode = result.qr_tag
            // console.log("QR = ",this.channel.sub_channel)
            // console.log("QR = ",this.channel.sub_key)
            console.log("QRC = ",result.sub_channel)
            console.log("QRK = ",result.sub_key)
            setTimeout(function () {
              this.$store.state.isLoading = false
              this.setTimeOut()
            }.bind(this), 1500)
            client.subscribe({
              // key: "aArZ5ThGcFCRJ0UumrK6YcssjRhAmEKD",
              key: this.channel.sub_key,
              channel: this.channel.sub_channel
            })
          } else {
            client.unsubscribe({
              // key: "aArZ5ThGcFCRJ0UumrK6YcssjRhAmEKD",
              key: result.sub_key,
              channel: result.sub_channel
            });
            this.$store.state.isLoading = true
            if (this.chceck_genqr == 3) {
              this.$store.state.isLoading = false
              swal.fire({
                title: 'Gen QRCode ERROR',
                text: "สถานะการตอบกลับ " + result.status,
                type: 'error',
                animation: true,
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'OK !'
              }).then((result) => {
                if (result.value) {
                  this.$router.push({
                    name: 'Main'
                  })
                } else {
                  this.$router.push({
                    name: 'Main'
                  })
                }
              })
            } else {
              this.chceck_genqr += 1
              this.genqrcode()
            }
          }
        },
        (error) => {
          alert(JSON.stringify(error))
        })
    },
    setTimeOut() {
      if (this.$route.name === 'ProcessPromptpay'){
        this.tt = setInterval(function () {
          this.time--
          console.log("time_pp:",this.time)
          if (this.time === 0) {
            clearInterval(this.tt)
            // client.disconnect();
            // clearInterval(this.step_process)
            this.$store.state.printer_step = 2
            let text = ''
            let title = ''
            switch (this.lang) {
              case 0:
                text = 'You did not complete the transaction at the specified time.'
                title = 'Warning'
                break
              case 2:
                text = '您未在指定時間完成交易。'
                title = '通知'
                break
              default:
                text = 'ท่านไม่ได้ทำรายการตามเวลาที่กำหนด'
                title = 'แจ้งเตือน'
                break
            }
            swal(
              title,
              text,
              'warning'
            )
            // cancel promptpay
            const obj = {
              vending_uuid: this.UUID,
              order_uuid: this.txn_id,
              ref1: this.channel.ref1,
              reason: "timeout"
            }
            api.cancelPromptpay(obj, this.header,
              result => {
                if (result.status == 'success') {
                  // this.$router.go(-1)
                  this.$router.push({
                    name: 'Main'
                  })
                } else {
                  alert(JSON.stringify(result))
                  // this.$router.go(-1)
                  this.$router.push({
                    name: 'Main'
                  })
                }
              },
              error => {
                alert(JSON.stringify(error))
                // this.$router.go(-1)
                this.$router.push({
                  name: 'Main'
                })
              }
            )
          }
        }.bind(this), 1000)
      } else {
        clearInterval(this.tt)
        clearInterval(this.step_process)
      }
    },
    openSale() {
      this.$store.state.isLoading = true
      api.openSale(this.header, result => {
        console.log(result)
        this.txn_id = result.txn_id
        this.$store.state.sale_info = result.info
        this.genqrcode()

      },
        error => {
          alert(JSON.stringify(error))
        })
    },
    Payment() {
      const header = {
        headers: {
          'x-access-token': this.accessToken
        }
      }
      if (this.SaleID == 1) {
        var mode = 'Deposit'
        var payment_type_text = 'Credit'
        var type_text = 'Credit'
        if (this.SaleType == 1) {
          switch (this.lang) {
            case 0:
              payment_type_text = 'Promptpay'
              type_text = 'Wallet'
              mode = 'Deposit'
              break;
            case 1:
              payment_type_text = 'พร้อมเพย์'
              type_text = 'เติมเงิน Wallet'
              mode = 'เติมเงิน'
              break;
            case 2:
              payment_type_text = 'Promptpay'
              type_text = 'Wallet'
              mode = '存款'
              break;
          }
        }

        this.$store.state.sale_subs = [{
          line: 1,
          item_id: '0',
          item_name: payment_type_text,
          qty: 1,
          price_id: 1,
          price_name: type_text,
          price: parseFloat(this.AmountPayment),
          unit: ""
        }]
      }
      console.log('IDWallet : '+this.IDWallet)
      if (!this.IDWallet) {
        if (this.IDWallet == null) {
          this.$store.state.IDWallet = ''
          this.walletChangeID.forEach((val) => {
            if (val['data'] != '-') {
              this.$store.state.IDWallet += val['data']
            }
          })
        }
      } else {
        var numberPhone = this.IDWallet.substring(1, this.IDWallet.length)
      }
      var saletype = ''
      switch (this.SaleID) {
        case 1:
          saletype = 'deposit_promtpay'
          break
        case 2:
          saletype = 'sale_promtpay'
          break
        case 3:
          saletype = ''
          break
        case 4:
          saletype = 'sale_promtpay'
          break
        case 5:
          saletype = 'sale_promtpay'
          break
        default:
          saletype = 'deposit'
          break
      }
      if (this.$store.state.SaleID !== 5) {
        this.$store.state.ref_number = this.$store.state.txn_id
        this.status_partner = false
      } else {
        this.status_partner = true
      }
      // var numberPhone = this.IDWallet.substring(1, this.IDWallet.length);
      // this.$store.state.AmountPayment = this.$store.state.total
      console.log("ref_number = " + this.$store.state.ref_number)
      console.log("txn_id = " + this.txn_id)
      console.log("total = " + this.$store.state.total)
      this.payload = {
        shift_uuid: this.$store.state.shift_uuid,
        ref_number: this.$store.state.ref_number,
        txn_id: this.$store.state.txn_id,
        type: saletype,
        partner: this.status_partner,
        member_phone: '+66' + numberPhone,
        member_name: '',
        flag_member: this.$store.state.flag_member,
        amount: parseFloat(this.AmountPayment),
        payment_received: parseFloat(this.AmountPayment),
        payment_change: 0,
        payment: {
          promptpay: parseFloat(this.AmountPayment)
        },
        items: this.$store.state.sale_subs
      }
      console.log(JSON.stringify(this.payload))
      if (this.AmountPayment >= this.$store.state.total) {
        this.$store.state.isLoading = true
        api.closeSaleV2(this.payload, header,
          result => {
            console.log(result)
            if (result.response == 'success') {
              // this.printBill()
              setTimeout(() => {
                if(this.SaleID == 1){
                } else {
                var data_slip = {
                  "command": "print_slip",
                  "data": {
                    "client_tax_id": "",
                    "shop_title": this.$store.state.config.client.shop_title,
                    "shop_website": this.$store.state.config.client.shop_website,
                    "logo_image_width": 300,
                    "total": parseFloat(this.$store.state.total),
                    "payment": parseFloat(this.AmountPayment),
                    "change": (parseFloat(this.$store.state.total)-parseFloat(this.AmountPayment))*(-1),
                    "type": "take_home",
                    "unchange": 0,
                    "status": 0,
                    "queue_no": result.queue,
                    "sale_pay": {},
                    "sale_subs": this.$store.state.sale_subs_slip
                  }
                }
                console.info(JSON.stringify(data_slip))
                this.$socket.sendObj(data_slip)
                }
              }, 3000);
              const obj = {
                ref_number: this.$store.state.ref_number,
                status: "PROCESSING"
              }
              if (this.$store.state.SaleID == 5) {
                api.getReceiveC9(obj, header,
                  result => {
                    console.log("result :",result)
                    // client.disconnect();
                    setTimeout(() => {
                      this.$store.state.printer_step = 2
                      console.log(this.$store.state.acl)
                      if (this.$store.state.acl === 1) {
                        this.$socket.sendObj({
                          command: 'open_cash_box',
                          data: 10
                        })
                        switch (this.lang) {
                          case 0:
                            this.sayLang('Thankyou')
                            break
                          case 2:
                            this.sayLang('謝謝')

                            break
                          default:
                            this.sayLang('ขอบคุณค่ะ')

                            break
                        }
                      }
                    }, 2000)
                  }, error => {
                    alert(JSON.stringify(error))
                  }
                )
              } else {
                // client.disconnect();
                console.log("this.$store.state.SaleID != 5")
                setTimeout(() => {
                  this.$store.state.printer_step = 2
                  switch (this.lang) {
                    case 0:
                      this.sayLang('Thankyou')
                      break
                    case 2:
                      this.sayLang('謝謝')
                      break
                    default:
                      this.sayLang('ขอบคุณค่ะ')
                      break
                  }
                  this.$router.push({
                    name: 'Main'
                  })
                }, 5000)
              }
              // setTimeout(() => {
              //   this.$router.push({
              //     name: 'Main'
              //   })
              // },3000)
            } else {
              alert("Error " + JSON.stringify(result))
            }
            this.$store.state.isLoading = false
          },
          error => {
            // client.disconnect();
            console.log(JSON.stringify(error))
            this.$store.state.isLoading = false
            alert('ERROR Payment = ' + JSON.stringify(error))
          })
      }
      // } else {
      //     this.payload = {
      //       shift_uuid: this.$store.state.shift_uuid,
      //       ref_number: this.ref1,
      //       partner: false,
      //       member_phone: null,
      //       amount: parseFloat(this.$store.state.total),
      //       payment_received: parseFloat(this.AmountPayment),
      //       payment_change: parseFloat(this.AmountPayment) - parseFloat(this.$store.state.total),
      //       payment: {
      //         currency: "THB",
      //         b1000: this.sale_pay.b1000,
      //         b500: this.sale_pay.b500,
      //         b100: this.sale_pay.b100,
      //         b50: this.sale_pay.b50,
      //         b20: this.sale_pay.b20,
      //         c10: this.sale_pay.c10,
      //         c5: this.sale_pay.c5,
      //         c2: this.sale_pay.c2,
      //         c1: this.sale_pay.c1,
      //         c050: 0,
      //         c025: 0,
      //         creditcard: 0,
      //         promptpay: 0,
      //         wechat: 0,
      //         alipay: 0,
      //         c9: 0
      //       },
      //       items: this.$store.state.sale_subs
      //     }
      //     console.log('Sale' + JSON.stringify(this.payload))
      //     if (this.AmountPayment >= this.$store.state.total) {
      //       this.$store.state.isLoading = true
      //       api.closeSalePromptpay(this.payload, header,
      //         result => {
      //           console.log(result)
      //           if (result.result == 'success') {
      //             // this.printBill()
      //             client.disconnect();
      //             setTimeout(() => {
      //               this.$store.state.printer_step = 2
      //             }, 2000)
      //           } else {
      //             alert('NOT success = ' + JSON.stringify(result))
      //           }
      //         },
      //         error => {
      //           alert('ERROR Payment = ' + JSON.stringify(error))
      //         })
      //     }
      // }
    },
    printBill() {
      var mode = 'Deposit'
      var sale_type_text = 'Promptpay'
      var type_text = 'Wallet'
      if (this.SaleType == 1) {
        switch (this.lang) {
          case 0:
            payment_type_text = 'Promptpay'
            type_text = 'Wallet'
            mode = 'Deposit'
            break;
          case 1:
            payment_type_text = 'Promptpay'
            type_text = 'เติมเงิน Wallet'
            mode = 'เติมเงิน'
            break;
          case 2:
            payment_type_text = 'Promptpay'
            type_text = 'Wallet'
            mode = '存款'
            break;
        }
      }
      // console.log(this.sale_info)
      if (this.SaleID == 1) {
        this.$store.state.sale_subs = [{
          line: 1,
          item_id: '0',
          item_name: sale_type_text,
          qty: 1,
          price_id: 1,
          price_name: type_text,
          price: parseFloat(this.AmountPayment),
          unit: ""
        }]
      }

      const payload = {
        command: "print_slip",
        data: {
          client_tax_id: this.sale_info.tax_id,
          shop_title: this.sale_info.shop_title,
          shop_website: this.sale_info.shop_website,
          logo_image_width: this.sale_info.logo_image_width,
          total: parseFloat(this.AmountPayment),
          payment: parseFloat(this.AmountPayment),
          change: 0,
          type: mode,
          unchange: 0,
          status: 0,
          queue_no: 1,
          sale_pay: {
            C1: this.sale_pay.c1,
            C2: this.sale_pay.c2,
            C5: this.sale_pay.c5,
            C10: this.sale_pay.c10,
            B20: this.sale_pay.b20,
            B50: this.sale_pay.b50,
            B100: this.sale_pay.b100,
            B500: this.sale_pay.b500,
            B1000: this.sale_pay.b1000
          },
          sale_subs: this.$store.state.sale_subs
        }
      }
      this.$socket.sendObj(payload)
      console.log(payload)
    },
    onMessagePromptpay() {
      client.on('message', function (msg) {
        var msg = msg.asObject()
        console.log('tag',msg )
        // alert(JSON.stringify(msg))
        // if (msg.status === 'success') {
        //   if (msg.message === 'payment success') {
        //     console.log("QR massage = " + msg)
        //     this.step = 2
        //     this.ref1 = msg.ref1
        //     this.remark = msg.confirmed_at
        //     clearInterval(this.tt)
        //     this.Payment()
        //   }
        // } else {
        //   // console.clear()
        //   console.log("onMessagePromptpay error")
        //   swal("Error Payment!", "Try Again !!!", "error").then(function () {
        //     clearInterval(this.tt)
        //     // this.genqrcode()
        //     alert("mas qr = " + JSON.stringify(msg))
        //   }.bind(this));
        // }
      }.bind(this))
    },
    websocket_onmessage() {
      this.$socket.onmessage = skResult => {
        this.$store.commit('onMessageWs', JSON.parse(skResult.data))
      }
    }
  },
  mounted() {
    this.websocket_onmessage()
    this.setHeader()
    this.Payment()
    // this.openSale()
    // // client.connect()
    // // this.onMessagePromptpay()
    // this.websocket_onmessage()
    // this.$store.state.total = this.AmountPayment
    // console.log('saleID = ' + this.SaleID)
    // console.log('saleType = ' + this.SaleType)
    // console.log('this.$store.state.printer_step = ' + this.$store.state.printer_step)
    // this.step_process = setInterval(function () {
    //   console.log('loop' )
    //   if (this.$store.state.printer_step == 2) {
    //     this.$store.state.printer_step = 1
    //     this.$store.commit('clearState')
    //     clearInterval(this.step_process)
    //     clearInterval(this.tt)
    //     this.tt = ''
    //     this.time = 180
    //     console.log('printer_step = ' + this.$store.state.printer_step)
    //     if (this.$store.state.printer_step == 1) {
    //       console.log('printer_step = ' + this.$store.state.printer_step)
    //       this.$router.push({
    //         name: 'Main'
    //       })
    //     }
    //     location.reload() //แก้clientไม่ออก
    //   }
    // }.bind(this), 1000)
  }
}



// WEBPACK FOOTER //
// ./src/js/pp.js